const {Popup} = require("../components/popup/popup");
const {Dropdown} = require("../components/dropdown/dropdown");
const {Card} = require("../components/card/card");

window.CatalogFilter = {
    el   : {
        filterBtnCancel : '[data-filter-cancel]', // кнопка отменить
        //filterBtnApply          : '', // кнопка "применить фильтр"
        catalogFilter       : '[data-filter]',
        catalogFilterInputs : '[data-filter] input',
        ajaxContent         : '[data-catalog-container]',
        catalogSortInputs   : '[data-sort-by]',
        catalogItemsCount   : '[data-catalog-results-amount]',
    },
    func : {
        // обновление ajax контента
        updateAjaxContent : function(html) {
            $(CatalogFilter.el.ajaxContent).html(html.content);
            $(CatalogFilter.el.catalogItemsCount).html(html.items_count);

            this.updateLazy();
            this.updateCards();
            this.updateFavorites();
            this.updateCardCountButtons();
        },

        updateLazy : function() {
            let img = $(CatalogFilter.el.ajaxContent).find('.lazyload');
            let lazy = new LazyLoad(img);
            lazy.loadImages();
        },

        updateCards: function() {
            $('[data-product-container]').find('[data-card]').each(function(i) {
                let card = new Card($(this));
                card.initialize();
            });
        },

        updateFavorites: function() {
            if (typeof window.Favorites !== 'undefined') {
                window.Favorites.initLinks();
            }
        },

        updateCardCountButtons: function() {
            if (typeof window.checkCardCountButtons !== 'undefined') {
                window.checkCardCountButtons();
            }
        },

        reloadCatalog(show_filter = 0) {
            let $form = $(CatalogFilter.el.catalogFilter), dataSerialize = $form.serialize() + '&set_filter=Показать', action = $form.attr('action');
            let url = window.location.search;

            // сортировка
            let sortValue = $(CatalogFilter.el.catalogSortInputs + '.active').data('sort-by');
            if (sortValue) {
                dataSerialize += '&sort=' + sortValue;
            }

            // поиск
            let searchQuery = Jamilco.getParamFromUrl(url, 'q');
            if (searchQuery.length > 0) {
                dataSerialize += '&q=' + searchQuery;
            }

            if (show_filter) {
                dataSerialize += '&show_filter=Y';
            }

            let accordionStates = {};

            $('[data-filter-name]').each(function() {
                const filterName = $(this).data('filter-name');
                const hasShowClass = $(this).find('.accordion').hasClass('show');
                accordionStates[filterName] = hasShowClass; // Сохраняем состояние
            });

            $('body').addClass('body--loading');
            $.ajax({
                type     : 'GET',
                dataType : 'JSON',
                url      : action,
                data     : dataSerialize,
                success  : function(response) {
                    // Временный контейнер
                    const $tempContainer = $('<div>').html(response.content);

                    // Применяем сохраненные состояния к элементам внутри временного контейнера
                    $tempContainer.find('[data-filter-name]').each(function() {
                        const filterName = $(this).data('filter-name');
                        const $accordion = $(this).find('.accordion');

                        // Устанавливаем или убираем класс show на основе сохранённого состояния
                        if (accordionStates[filterName]) {
                            $accordion.addClass('show');
                        } else {
                            $accordion.removeClass('show');
                        }
                    });

                    response.content = $tempContainer.html();

                    CatalogFilter.func.updateAjaxContent(response);

                    // Инициализируем dropdown после ajax
									  var drop = new Dropdown($('.dropdown'));
									  drop.initialize();

                    // выводим чпу-ссылку в строке браузера
                    //let query = window.location.search;
                    //let params = Jamilco.makeParams(query, ['set_filter', 'del_filter', 'showMore'])

                    let sefUrl = window.setFilterUrl.replace('filter/clear/apply/', '');
                    if (sortValue.length > 0 && !/default/.test(sortValue)) {
                        sefUrl = Jamilco.addParamToURL(sefUrl, 'sort', sortValue);
                    }
                    if (searchQuery.length > 0) {
                        sefUrl = Jamilco.addParamToURL(sefUrl, 'q', searchQuery);
                    }
                    Jamilco.removeParamFromURL(sefUrl);

                    $('[data-catalog-tool].active').click();

                    $('body')
                        .removeClass('body--loading')
                        .removeClass('overflow')
												.removeClass('overflow-y');

										let catalogTop = $(CatalogFilter.el.ajaxContent).offset().top - $('[data-header]').innerHeight() - parseInt($('[data-filter-container]').parent().css('padding-top'));

										$('html, body').stop().animate({scrollTop: catalogTop + 'px'}, 500);
                },
                error    : function(xhr, str) {
                    console.log(xhr.responseCode);
										$('body')
											.removeClass('body--loading')
											.removeClass('overflow')
											.removeClass('overflow-y');
                }
            })
        },

        clearCatalogFilter() {
            let $form = $(CatalogFilter.el.catalogFilter);
            let action = $form.attr('action');
            let data = {
                del_filter : 'Сбросить',
            };

            let url = window.location.search;

            // сортировка
            let sortValue = Jamilco.getParamFromUrl(url, 'sort');
            if (sortValue.length > 0 && !/default/.test(sortValue)) {
                action = Jamilco.addParamToURL(action, 'sort', sortValue);
            }

            // поиск
            let searchQuery = Jamilco.getParamFromUrl(url, 'q');
            if (searchQuery.length > 0) {
                action = Jamilco.addParamToURL(action, 'q', searchQuery);
            }

            $('body').addClass('body--loading');
            $.ajax({
                type     : 'GET',
                dataType : 'JSON',
                url      : action,
                data     : data,
                success  : function(response) {
                    CatalogFilter.func.updateAjaxContent(response);

                    let sefUrl = window.delFilterUrl;
                    if (sortValue.length > 0 && !/default/.test(sortValue)) {
                        sefUrl = Jamilco.addParamToURL(sefUrl, 'sort', sortValue);
                    }
                    if (searchQuery.length > 0) {
                        sefUrl = Jamilco.addParamToURL(sefUrl, 'q', searchQuery);
                    }
                    Jamilco.removeParamFromURL(sefUrl.replace('filter/clear/apply/', ''));

                    $('[data-catalog-tool].active').click();

										$('body')
											.removeClass('body--loading')
											.removeClass('overflow')
											.removeClass('overflow-y');
                },
                error    : function(xhr, str) {
                    console.log(xhr.responseCode);
										$('body')
											.removeClass('body--loading')
											.removeClass('overflow')
											.removeClass('overflow-y');
                }
            })
        }
    }
}

$(document).ready(function() {
	// перегрузить фильтр
	$(document).on('click', CatalogFilter.el.catalogFilterInputs, function() {
		let name = $(this).attr('name');
		if (!/arrCatalogFilter_/.test(name)) return;
        CatalogFilter.func.reloadCatalog(1);
	})

	// обработка кликов по элементам сортировки
	$(document).on('click', CatalogFilter.el.catalogSortInputs, function() {
        CatalogFilter.func.reloadCatalog();
	})

	// очистить фильтр
	$(document).on('click', CatalogFilter.el.filterBtnCancel, function() {
        CatalogFilter.func.clearCatalogFilter();
	})
});
